// extracted by mini-css-extract-plugin
export default {"wrapper":"Advantages_wrapper__HLk7u","img":"Advantages_img__akpAS","Advantages":"Advantages_Advantages__d+hv-","wrapper2":"Advantages_wrapper2__Ze9rN"};